import en from "./en.json";
import it from "./it.json";

const sidebar = { en, it };

export default sidebar;
